<template>
  <default-layout>
    <template slot="left">
      <router-link v-if="lesson" tag="div" :to="{name: 'subject',params: {slug:lesson.subject_slug}}"
                   class="bg-dark cursor-pointer p-2 list-group-item d-flex mb-4">
        <img class="mr-2" src="@img/arrow-back.svg" alt="">
        <img class="mr-2" src="@img/grid.svg" alt="">
        <span class="text-white">Liste des cours</span>
      </router-link>
      <left-side-bar-bottom/>
    </template>
    <template slot="center">
      <template v-if="lesson">
        <div class="fw-600" style="font-size: 14px">Leçon:</div>
        <div v-if="lesson" class="fw-800" style="font-size: 22px">{{ lesson.title }}</div>
      </template>
      <div class="white-card py-5" style="min-height: 300px">
        <div class="loader absolute" v-if="loading"></div>
        <div v-else-if="lesson" class="row">
          <div class="col-md-6">
            <img src="@img/lesson.svg" class="w-100">
          </div>
          <div class="col-md-6">
            <div class="blocks">
              <router-link v-if="lesson.has_videos" tag="div"
                           :to="{name:'lesson-video',params: {slug: lesson.slug,lesson}}" class="block">
                <img src="@img/video.svg" alt="">
                <div>Video</div>
              </router-link>
              <router-link v-if="lesson.has_course" tag="div" :to="{name:'course',params:{slug: lesson.slug, lesson}}"
                           class="block">
                <img src="@img/course.svg" alt="">
                <div>Fiche de cours</div>
              </router-link>
              <router-link v-if="lesson.has_course_complete" tag="div"
                           :to="{name:'course',params:{slug: lesson.slug, lesson},query: {complete: true}}"
                           class="block">
                <img src="@img/course_complete.svg" alt="">
                <div>Cours complet</div>
              </router-link>
              <router-link v-if="lesson.has_exercises" tag="div"
                           :to="{name: 'lesson-exercises',params: {slug: lesson.slug}}" class="block">
                <img src="@img/exercise.svg" alt="">
                <div>Exercices</div>
              </router-link>
              <router-link v-if="lesson.has_quiz" tag="div" :to="{name: 'lesson-quiz',params: {slug: lesson.slug}}"
                           class="block">
                <img src="@img/quiz.svg" alt="">
                <div>Quiz</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </template>
  </default-layout>
</template>
<script>

import DefaultLayout from "@/Layout/DefaultLayout";
import LeftSideBarBottom from "@/components/LayoutPartials/LeftSideBarBottom";

export default {
  components: {LeftSideBarBottom, DefaultLayout},
  data() {
    return {
      lesson: null,
      loading: false
    }
  },
  watch: {
    '$route.params.slug'() {
      this.load()
    }
  },
  methods: {
    load() {
      this.loading = true
      this.$store.dispatch('lesson/fetchItem', this.$slugId(this.$route.params.slug))
        .then(data => {
          this.lesson = data
          this.$store.commit('lesson/set_active', data)
        })
        .then(() => this.loading = false)
    }
  },
  beforeMount() {
    this.load()
  }
}
</script>

<style lang="scss" scoped>


.blocks {
  color: #757575;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @include gap-items-x(1%);

  > * {
    &:nth-child(2n+1) {
      margin-right: 0;
    }

    &:nth-child(2n) {
      margin-left: 0;
    }
  }

  .block {
    cursor: pointer;
    padding: 15px 20px;
    width: 48%;
    border: 1px $gray solid;
    color: black;
    font-size: 16px;
    font-weight: 700;
    border-radius: 5px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    img {
      width: 50px;
      margin-right: 30px;
      @include down(768) {
        width: 30px;
        margin-right: 15px;
      }
    }

    &:hover {
      background: $gray;
    }
  }
}


</style>
